import { faTimes } from '@awesome.me/kit-24322b77ac/icons/classic/regular';
import type { JSX } from 'react';

import { Icon } from '../Icon/Icon';
import { Button } from './Button';

export const CloseButton = ({ onClick }: { onClick: () => void }): JSX.Element => {
  return (
    <Button type="unstyled" className="bw-button-close" onClick={onClick} aria-label="Close">
      <Icon icon={faTimes} color="grey" />
    </Button>
  );
};
